import { AVAILABLE_LANGUAGES } from '@/constants';
import { SylndrHelpSectionMobile } from './sylndr-help-mobile';
import { CarTypesEnum } from '../../car-type';
import { SylndrHelpSectionDesktop } from './sylndr-help-desktop';
import { useState } from 'react';
import { SylndrHelpPoint } from './sylndr-help.types';
import { SylndrHelpContent } from './SylndrHelpContent';

export const SylndrHelpSection = ({
    carType,
    lang,
    IS_DESKTOP,
    inspectionRef = null,
    clickable = true,
}: {
    carType: CarTypesEnum;
    lang: AVAILABLE_LANGUAGES;
    IS_DESKTOP: boolean;
    inspectionRef?: React.RefObject<HTMLDivElement>;
    clickable?: boolean;
}) => {
    const [openContent, setOpenContent] = useState(false);
    const [selectedSection, setSelectedSection] =
        useState<SylndrHelpPoint>(null);

    const handleClickOnSection = (section: SylndrHelpPoint) => {
        if (clickable) {
            setSelectedSection(section);
            setOpenContent(true);
        }
    };
    return (
        <>
            {carType === CarTypesEnum.Dealer && (
                <>
                    <div className="hidden md:block">
                        <SylndrHelpSectionDesktop
                            lang={lang}
                            handleClickOnSection={handleClickOnSection}
                        />
                    </div>
                    <div className="block md:hidden">
                        <SylndrHelpSectionMobile
                            lang={lang}
                            handleClickOnSection={handleClickOnSection}
                            clickable={clickable}
                        />
                    </div>

                    {openContent && selectedSection && (
                        <SylndrHelpContent
                            inspectionRef={inspectionRef}
                            section={selectedSection}
                            lang={lang}
                            openContent={openContent}
                            setOpenContent={setOpenContent}
                            IS_DESKTOP={IS_DESKTOP}
                        />
                    )}
                </>
            )}
        </>
    );
};
